import React from 'react';
import { getSearchResult } from '../actions/searchAction';
import { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Select from 'react-select';

const phoneTypeOptions = [
    { label: 'Pre-sales', value: 'Pre-sales' },
    { label: 'Post-sales', value: 'Post-sales' }
]

class AddAudienceWhatsapp extends Component {

    constructor() {
        super();
        this.myRef = React.createRef();
        this.state = {
            audienceData: {}
        };
    }

    componentWillReceiveProps({  }) {
        
    }

    AddAudienceInput = ({ label, name, type, required = true, inputParams = {} }) => {
        return (
            <div className="col-12 col-md-2 addVendorInput">
                <div className="form-group">
                    <div className="mb-3">
                        <label>{`${label} ${required ? '*' : ''}`}</label>
                        <input className="form-control customInput" type={type} name={name} placeholder={label} onChange={(e) => this.handleAddAudienceInputChange(e)} {...inputParams} required={required} />
                    </div>
                </div>
            </div>
        )
    }

    AddAudienceInputFile = ({ label, name, required = true, inputParams = {} }) => {
        return (
            <div className="col-12 col-md-2 addVendorInput">
                <div className="form-group">
                    <div className="mb-3">
                        <label>{`${label} ${required ? '*' : ''}`}</label>
                        <input className="form-control customInput" type={"file"} name={name} placeholder={label} onChange={(e) => this.handleAddAudienceInputFileChange(e)} {...inputParams} required={required} accept=".csv" />
                    </div>
                </div>
            </div>
        )
    }

    AddAudienceSelect = ({ label, name, options = [], required = false }) => {
        return (
            <div className="col-12 col-md-2 addVendorInput">
                <div className="form-group">
                    <div className="mb-3">
                        <label>{`${label} ${required ? '*' : ''}`}</label>
                        <Select
                            isSearchable={true}
                            placeholder={label}
                            name={name}
                            options={options}
                            onChange={(e) => this.handleAddAudienceSelectChange(e, name)}
                            isMulti={false}
                        />
                    </div>
                </div>
            </div>
        )
    }

    handleAddAudienceInputChange = (e) => {
        let { name, value } = e.target;
        let { audienceData = {} } = this.state;
        audienceData[name] = value;
        this.setState({
            audienceData
        })
    }

    handleAddAudienceInputFileChange = (e) => {
        let { name } = e.target;
        let file = e.target.files[0];
        console.log(name, file);
        let { audienceData = {} } = this.state;
        audienceData[name] = file;
        this.setState({
            audienceData
        })
    }

    handleAddAudienceSelectChange = (e, name) => {
        console.log(e, name);
        let value = e.value;
        let { audienceData = {} } = this.state;
        audienceData[name] = value;
        this.setState({
            audienceData
        })
    }

    handleSubmitForm = (e) => {
        e.preventDefault();
        let { audienceData = {} } = this.state;
        console.log("Submit", audienceData);
        this.props.addAudienceWhatsapp(audienceData);
    }

    downloadCsvFormat = (type) => {
        if(!type) return;
        this.props.downloadAudFormat(type);
    }

    render() {

        let { AddAudienceInput, handleSubmitForm, AddAudienceSelect, AddAudienceInputFile } = this;

        return (
            <div className="procurementAddVendor">
                <h4 className="procurementAddVendorHeading">Add Audience</h4>
                <div>
                    <div style={{ float: 'right' }}>
                        <span className="mr-3" style={{ fontSize: '14px' }}>Download Format</span>
                        <span className="mr-3"><button className="btn btn-outline-success" onClick={() => this.downloadCsvFormat('preSales')}>Pre-sales</button></span>
                        <span><button className="btn btn-outline-success" onClick={() => this.downloadCsvFormat('postSales')}>Post-sales</button></span>
                    </div>
                    <div style={{ clear: 'both' }}></div>
                </div>
                <form onSubmit={handleSubmitForm} ref={this.myRef}>
                    <div className="addVendorForm">
                        <div className="row">
                            <AddAudienceInput
                                label="Audience Name"
                                name="audienceName"
                                type="text"
                                required={true}
                            />
                            <AddAudienceInputFile
                                label="File"
                                name="file"
                                required={true}
                            />
                            <AddAudienceSelect
                                isMulti={false}
                                label="Phone type"
                                name="phoneType"
                                required={true}
                                inputParams={{
                                    min: 0,
                                    max: 100
                                }}
                                options={phoneTypeOptions}
                            />
                        </div>
                        <button type="submit" className="btn btn-outline-success" style={{ float: 'right' }}>Submit</button>
                        <div style={{ clear: 'both' }}></div>
                    </div>
                </form>
            </div>
        )
    }
}

function mapStateToProps() {
    return {};
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ getSearchResult }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AddAudienceWhatsapp);